/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * The red/amber/green band.
 */
export enum DashboardStatusItemDtoBand {
  ON_TRACK = "ON_TRACK",
  NEEDS_ATTENTION = "NEEDS_ATTENTION",
  ACTION = "ACTION",
  NO_STATUS = "NO_STATUS",
}
